import React, { useContext, useState } from 'react';
import { IUserContext, IUserContextProviderProp, IUserProfile } from './UserContext.types';
import { CustomerType, STATE } from '../types';

export const UserContext = React.createContext<IUserContext | undefined>(undefined);

export const UserContextProvider: React.FC<IUserContextProviderProp> = (props) => {
  const {
    children,
    customerType: initialCustomerType,
    state: initialState,
    userProfile: initialUserProfile,
  } = props;

  const [customerType, setCustomerType] = useState<CustomerType | undefined>(initialCustomerType);
  const [state, setState] = useState<STATE | undefined>(initialState);
  const [userProfile, setUserProfile] = useState<IUserProfile | undefined>(initialUserProfile);

  const context: IUserContext = {
    state,
    customerType,
    userProfile,
    setState,
    setCustomerType,
    setUserProfile,
  };

  return <UserContext.Provider value={context}>{children}</UserContext.Provider>;
};

export const useUserContext = () => {
  const context = useContext<IUserContext | undefined>(UserContext);
  if (context === undefined) {
    throw new Error('useUserContext must be used within a UserContext');
  }
  return context;
};
